import {
  Button,
  Checkbox,
  Dialog,
  DialogActions,
  DialogContent,
  DialogTitle,
  List,
  ListItem,
  ListItemButton,
  ListItemIcon,
  ListItemText,
} from '@mui/material';
import { useAppSelector } from 'app/hooks';
import { zonedTimeToUtc } from 'date-fns-tz';
import { useUserDateTime } from 'features/timezone/hooks/useUserDateTime';
import { useState } from 'react';
import { useWalls } from './api/getWalls';

const ExportWallDialog = () => {
  const userId = useAppSelector((state) => state.auth.user?.id) || -1;
  const { timezone } = useUserDateTime();
  const { data: walls } = useWalls(userId);
  const [open, setOpen] = useState<boolean>(false);
  const [checkedWallIds, setCheckedWallIds] = useState<number[]>([]);

  const handleWallChecked = (wallId: number) => {
    if (checkedWallIds.includes(wallId)) {
      setCheckedWallIds(checkedWallIds.filter((id) => id !== wallId));
    } else {
      setCheckedWallIds([...checkedWallIds, wallId]);
    }
  };

  const handleExport = () => {
    const filteredWalls = walls?.filter((wall) =>
      checkedWallIds.includes(wall.id)
    );

    const element = document.createElement('a');
    const file = new Blob([JSON.stringify(filteredWalls)], {
      type: 'text/plain',
    });
    element.href = URL.createObjectURL(file);
    element.download = `spectras-walls-export-${zonedTimeToUtc(
      new Date(),
      timezone
    )
      .toISOString()
      .slice(0, 10)}`;
    document.body.appendChild(element);
    element.click();
  };

  return (
    <>
      <Button variant='contained' color='primary' onClick={() => setOpen(true)}>
        Export
      </Button>
      <Dialog
        open={open}
        onClose={() => setOpen(false)}
        fullWidth
        maxWidth={'sm'}
      >
        <DialogTitle>Export Walls</DialogTitle>
        <DialogContent>
          <List>
            {walls?.map((wall) => {
              return (
                <ListItem key={wall.id}>
                  <ListItemButton dense>
                    <ListItemIcon>
                      <Checkbox
                        edge='start'
                        checked={checkedWallIds.includes(wall.id)}
                        tabIndex={-1}
                        onChange={() => handleWallChecked(wall?.id)}
                      />
                    </ListItemIcon>
                    <ListItemText primary={wall?.name || ''} />
                  </ListItemButton>
                </ListItem>
              );
            })}
          </List>
        </DialogContent>
        <DialogActions>
          <Button onClick={() => setOpen(false)}>Cancel</Button>
          <Button onClick={handleExport}>Export</Button>
        </DialogActions>
      </Dialog>
    </>
  );
};

export default ExportWallDialog;
